export default __webpack_public_path__ + "static/media/grading-confusion-matrix-tabel.e8a58100.png";